import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {TokenMap} from "../../models/token-map";

declare var jQuery: any;

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.css']
})
export class ContentComponent implements OnInit {

  @Input() src: any;
  @Input() type: string;
  @Input() disabled: boolean;
  @Input() replaceId: string;
  @Input() origin: string;
  @Input() width: any;
  @Input() height: any;
  @Input() bannerCenterText: string;
  @Input() bannerCenterTextColor: any;
  @Input() callbackFunction: Function;
  @Input() tokenMap : TokenMap[] = [];
  public loading = false;
  private http: HttpClient;
  private html: any;
  private domSanitizer: DomSanitizer;

  private showContent = false;
  private showImage = false;
  private showBanner = false;

  private newSrc: string;

  // class initialization - called by js engine
  constructor(http: HttpClient, domSanitizer: DomSanitizer) {
    this.http = http;
    this.domSanitizer = domSanitizer;
  }

  // angular lifecycle hook - angular finished initializing this component
  ngOnInit(): void {
    const hostname: string = document.location.hostname;

    let uri: string = '/wcm' + this.src;

    switch (this.type) {
      case 'img':
        this.newSrc = uri;
        this.showImage = true;
        break;

      case 'banner':
        this.newSrc = uri;
        this.showBanner = true;
        break;

      default:
        this.loading = true;
        this.getContent(uri)
          .subscribe(
            result => {
              this.showContent = true;

              if (result) {
                if (this.replaceId) {
                  jQuery('#' + this.replaceId).html(result);
                } else {
                  this.html = result;
                }
              }

              if (this.callbackFunction) {
                this.callbackFunction();
              }

              this.loading = false;

              const self = this;
              setTimeout(function () {
                self.loading = false;
              }, 1000);
            }
          );
    }
  }

  getContent(src: string): Observable<any> {
    if (this.tokenMap.length > 0) {
      src = this.appendTokens(src, this.tokenMap);
    }
    return this.http.get(src, {responseType: 'text'})
      .pipe(
        map((response: string) => response.replace(/\\n/g, '')),
        catchError((error: HttpErrorResponse) => {
            return Observable.create(observer => {
              observer.next('<div class="alert alert-warning">Unable to load content.</div>');
              observer.complete();
            });
          }
        )
      );
  }

  customGetContent(src: string) {
    const hostname: string = document.location.hostname;

    if (src !== '') {
      this.src = src;
    }
    let uri: string = this.src;

    if (!uri.startsWith('data:')) {
      if (!uri.startsWith('/')) {
        uri = '/' + uri;
      }

      if (!this.origin || (this.origin && this.origin === 'HIPPO')) {
        if ((hostname.indexOf('localhost') !== -1) || (hostname.indexOf('test') !== -1)) {
          uri = '/site/preview' + uri;
        } else {
          uri = '/site' + uri;
        }
      }
    }

    switch (this.type) {
      case 'img':
        this.newSrc = uri;
        this.showImage = true;
        break;

      case 'banner':
        this.newSrc = uri;
        this.showBanner = true;
        break;

      default:
        this.loading = true;
        return this.getContent(uri);
    }
  }

  private appendTokens(src: string, tokenMap: TokenMap[]): string {
    src = src + '?processRequestTokens=true';
    tokenMap.forEach(token => {
      src = src + '&' + token.tokenName + '=' + token.tokenValue;
    });
    return src;
  }
}
